import { ViewLOSV3EventManagePage } from "./ViewLOSV3EventManagePage";

export default ViewLOSV3EventManagePage;
